import { HttpWebtrack } from 'utility/http';
import { ConfigActions } from '../../../../utility/http/http-events';

import configureInterceptors from 'utility/http/interceptors/configure-interceptors';
import { store } from '@redux/storeConfig/store';

export const baseUrl = '/location';

interface LocationSaveRequest {
  locationId?: number;
  isPublic?: number;
  dispatchCompletionType: number;
  dispatchEmails: string;
  dispatchNotificationFreq: number;
  enableDispatch: number;
  latitude: number;
  longitude: number;
  radius: number;
  locationName: string;
  locationTypeId: number;
  locationClassId: number;
  locationAddress?: string;
  privateCode?: string;
  organizationId: number;
  divisionId: number;
  subdivisionId: number;
  averageTime?: number;
  minTime?: number;
  maxTime?: number;
  startTime?: string;
  endTime?: string;
  averageCapacity?: number;
  minCapacity?: number;
  maxCapacity?: number;
}

interface LocationDeleteRequest {
  locationId: number;
  locationName: string;
}

interface LocationImportRequest {
  organizationId?: number | null;
  divisionId?: number | null;
  subdivisionId?: number | null;
  locations: string;
}

interface LocationFilters {
  operatorId?: number;
  organizationId?: number;
  userFetchDate?: Date;
  minLat?: number;
  maxLat?: number;
  minLng?: number;
  maxLng?: number;
  locationIds?: string;
  workplanExecutionId?: number;
}

export const getLocationsListService = (request: LocationFilters, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'locations.location',
    action: 'Get',
    genderType: 'PluralFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/get`, request);
};

export const saveLocationService = (
  request: LocationSaveRequest & {
    __messageObject?: string;
    __messageAction?: 'Create' | 'Edit' | 'Delete';
    __silent?: boolean;
  },
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  const { __messageObject, __messageAction, __silent, ...payload } = request;
  if (!__silent) {
    const isBranch = (payload as any)?.locationClassId === 34;
    httpWebtrack.setConfigMessage({
      object: __messageObject ?? (isBranch ? 'customers.branch' : 'locations.location'),
      action: __messageAction ?? (payload.locationId ? 'Edit' : 'Create'),
      name: payload.locationName,
      genderType: 'SingularFemale'
    });
  }
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/save`, payload);
};

export const deleteLocationService = (
  request: LocationDeleteRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  const isBranch = (request as any)?.locationClassId === 34;
  httpWebtrack.setConfigMessage({
    name: `${request.locationName}`,
    object: isBranch ? 'customers.branch' : 'locations.location',
    action: 'Delete',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/delete`, request);
};

export const importLocationsService = (
  request: LocationImportRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/importLocations`, request);
};

export const getLocationByIdService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'locations.location',
    action: 'Get',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getById`, request);
};

export const getWorkplanExecutionLocationsService = (
  request: { workplanExecutionId: number }, 
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'locations.location',
    action: 'Get',
    genderType: 'PluralFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  
  // Validación del parámetro requerido
  if (!request.workplanExecutionId) {
    throw new Error('workplanExecutionId is required');
  }
  
  return httpWebtrack.post(`${baseUrl}/getWorkplanExecutionLocations`, request);
};
